import { URL } from "../environment/variables";

export const getInfoTextService = async () => {

    try{
        const response = await fetch(`${URL}/cms/obtenerconfiguraciones/17204EF6-C3BF-4438-8007-5EB7B89FFEB3`, {
            mode: 'cors',
            method: 'GET',
            headers:{
                'Accept': '*/*',
            }
        })
        const json = await response.json()
        return json
    }catch(err){
        console.log(err)
    }

}